/* Shubha product page (new UI). No dependencies. */
(function () {
  'use strict';
  var fmt = function (cents) {
    var n = Math.round(cents) / 100;
    return '₹' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  };
  var each = function (list, fn) { Array.prototype.forEach.call(list, fn); };

  function openDrawer(cart, waited) {
    /* speed mode: the cart panel code starts on the first tap; if it is still starting, wait for it (max 5s) */
    if (!waited && !window.sharedFunctions && window.__shHold && !window.__shReleased) {
      var t = setTimeout(function () { openDrawer(cart, true); }, 5000);
      document.addEventListener('sh:released', function () { clearTimeout(t); setTimeout(function () { openDrawer(cart, true); }, 50); }, { once: true });
      if (window.shRelease) window.shRelease();
      return;
    }
    try {
      if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function' && document.getElementById('halo-cart-sidebar')) {
        document.body.classList.add('cart-sidebar-show');
        window.sharedFunctions.updateSidebarCart(cart);
        each(document.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = cart.item_count; });
        return;
      }
    } catch (e) {}
    window.location.href = '/cart';
  }

  function initProduct(root) {
    if (root.__sp) return; root.__sp = true;
    /* gallery photos 2+ are held until the page has loaded or the shopper touches the gallery */
    var lzDone = false;
    function lzRestore() {
      if (lzDone) return; lzDone = true;
      each(root.querySelectorAll('img[data-sp-lz]'), function (im) {
        if (im.getAttribute('data-sp-srcset')) im.setAttribute('srcset', im.getAttribute('data-sp-srcset'));
        if (im.getAttribute('data-sp-src')) im.setAttribute('src', im.getAttribute('data-sp-src'));
        im.removeAttribute('data-sp-lz');
      });
    }
    if (document.readyState === 'complete') { setTimeout(lzRestore, 300); } else { window.addEventListener('load', function () { setTimeout(lzRestore, 300); }); }
    var galEl = root.querySelector('[data-sp-gal]');
    if (galEl) { ['pointerdown', 'touchstart', 'focusin', 'mouseover'].forEach(function (ev) { galEl.addEventListener(ev, lzRestore, { passive: true, once: true }); }); }
    each(root.querySelectorAll('.sp-gal__dt, [data-sp-dots] button'), function (b) { b.addEventListener('click', lzRestore); });
    var form = root.querySelector('[data-sp-form]');
    var idInput = root.querySelector('[data-sp-id]');
    var errEl = root.querySelector('[data-sp-err]');
    var variants = [], cfg = {};
    try { variants = JSON.parse(root.querySelector('[data-sp-variants]').textContent); } catch (e) {}
    try { cfg = JSON.parse(root.querySelector('[data-sp-config]').textContent); } catch (e) {}
    var current = variants.filter(function (v) { return idInput && String(v.id) === idInput.value; })[0] || variants[0];
    var picked = !!cfg.single || /[?&]variant=/.test(window.location.search);

    /* ---- gallery ---- */
    var track = root.querySelector('[data-sp-track]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sp-dots] button'));
    var slides = track ? track.children : [];
    function idx() { return track ? Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)) : 0; }
    function go(i) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function fx() {
      if (still || !track) return;
      var W = track.clientWidth || 1, x = track.scrollLeft;
      for (var i = 0; i < slides.length; i++) {
        var m = slides[i].firstElementChild;
        if (!m || m.tagName === 'VIDEO') continue;
        var r = (i * W - x) / W, a = Math.min(Math.abs(r), 1);
        if (a < 0.002 || a >= 1) { if (m.__fx) { m.style.transform = ''; m.style.opacity = ''; m.__fx = 0; } continue; }
        m.style.transform = 'translate3d(' + (-r * W * 0.38).toFixed(1) + 'px,0,0) scale(' + (1 + a * 0.12).toFixed(3) + ')';
        m.style.opacity = (1 - a * 0.3).toFixed(3);
        m.__fx = 1;
      }
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { fx(); var i = idx(); dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); }); });
      }, { passive: true });
      var prev = root.querySelector('[data-sp-prev]'), next = root.querySelector('[data-sp-next]');
      if (prev) prev.addEventListener('click', function () { go(idx() - 1); });
      if (next) next.addEventListener('click', function () { go(idx() + 1); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-i')); }); });
    }

    /* ---- variants ---- */
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-sp-opt]'));
    function selected() { return groups.map(function (g) { var on = g.querySelector('.is-on'); return on ? on.getAttribute('data-v') : null; }); }
    function markAvailability() {
      var sel = selected();
      groups.forEach(function (g, gi) {
        each(g.querySelectorAll('.sp-pill'), function (p) {
          var test = sel.slice(); test[gi] = p.getAttribute('data-v');
          var ok = variants.some(function (v) { return v.available && v.options.every(function (o, k) { return o === test[k]; }); });
          p.classList.toggle('is-na', !ok);
        });
      });
    }
    function setText(sel, txt) { each(root.querySelectorAll(sel), function (el) { el.textContent = txt; }); }
    function toggle(sel, show) { each(root.querySelectorAll(sel), function (el) { el.hidden = !show; }); }
    function setAvailable(ok) {
      toggle('[data-sp-actions]', ok);
      toggle('[data-sp-soldout]', !ok);
      each(root.querySelectorAll('[data-sp-sk-btn]'), function (b) { b.disabled = !ok; b.textContent = ok ? (cfg.skText || 'Buy Now') : (cfg.soldText || 'Sold Out'); });
    }
    /* ---- live activity line (real data only) ---- */
    var liveVariant = null;
    (function () {
      var box = root.querySelector('[data-sp-live]'), txt = root.querySelector('[data-sp-live-t]'), dEl = root.querySelector('[data-sp-live-data]');
      if (!box || !txt || !dEl) return;
      var data; try { data = JSON.parse(dEl.textContent); } catch (e) { return; }
      var base = data.msgs || [], stockMsg = '', list = [], idx = 0, timer = null;
      function build() {
        list = stockMsg ? [stockMsg].concat(base) : base.slice();
        box.hidden = !list.length;
      }
      function show(i) {
        if (!list.length) return;
        idx = i % list.length;
        if (txt.textContent === list[idx]) return;
        txt.style.opacity = '0';
        setTimeout(function () { txt.textContent = list[idx]; txt.style.opacity = '1'; }, 300);
      }
      function start() { clearInterval(timer); if (list.length > 1) timer = setInterval(function () { if (!document.hidden) show(idx + 1); }, 4000); }
      liveVariant = function (v) {
        var q = data.stock && data.stock[String(v.id)];
        var label = cfg.single ? 'in stock' : 'in ' + (data.opt || 'size') + ' ' + (v.options || []).join(' / ');
        stockMsg = (picked && v.available && q && q <= (data.low || 5)) ? 'Only ' + q + ' left ' + label : '';
        build(); show(0); start();
      };
      if (picked && current) { liveVariant(current); } else { build(); if (list.length && !txt.textContent) txt.textContent = list[0]; start(); }
    })();
    function render(v) {
      if (!v) return;
      current = v;
      if (idInput) idInput.value = v.id;
      setText('[data-sp-price],[data-sp-vs-price],[data-sp-vs-pay]', fmt(v.price));
      /* coupon price bar: price after the coupon %, rounded up to the rupee */
      each(root.querySelectorAll('[data-sp-cpn]'), function (el) { var pct = +el.getAttribute('data-pct') || 0, t = el.querySelector('[data-sp-cpn-price]'); if (t) t.textContent = fmt(Math.ceil(v.price * (100 - pct) / 10000) * 100); });
      var diff = v.compare > v.price ? v.compare - v.price : 0;
      setText('[data-sp-compare]', fmt(v.compare));
      setText('[data-sp-off]', diff ? Math.round(diff * 100 / v.compare) + '% OFF' : '');
      toggle('[data-sp-compare],[data-sp-off]', diff > 0);
      var save = diff + (cfg.gift || 0);
      setText('[data-sp-vs-save]', fmt(save));
      toggle('[data-sp-vs-savebox]', save > 0);
      setAvailable(v.available);
      if (liveVariant) liveVariant(v);
      if (v.media && track) {
        for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') === String(v.media)) { go(i); break; } }
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var p = e.target.closest('.sp-pill'); if (!p) return;
        picked = true;
        each(g.querySelectorAll('.sp-pill'), function (x) { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        p.classList.add('is-on'); p.setAttribute('aria-checked', 'true');
        var sel = selected();
        var v = variants.filter(function (x) { return x.options.every(function (o, k) { return o === sel[k]; }); })[0];
        if (v) render(v); else setAvailable(false);
        markAvailability();
      });
    });
    if (groups.length) markAvailability();

    /* ---- dialogs (size guide + description panel) ---- */
    function openDlg(d) { if (!d) return; if (d.showModal) { if (!d.open) d.showModal(); } else d.setAttribute('open', ''); document.documentElement.classList.add('sp-lock'); }
    function closeDlg(d) { if (!d) return; if (d.close) d.close(); else d.removeAttribute('open'); document.documentElement.classList.remove('sp-lock'); }
    var guide = root.querySelector('[data-sp-guide]');
    var dd = root.querySelector('[data-sp-dd]');
    [guide, dd].forEach(function (d) {
      if (!d) return;
      d.addEventListener('click', function (e) { if (e.target === d) closeDlg(d); });
      d.addEventListener('close', function () { document.documentElement.classList.remove('sp-lock'); });
    });

    /* ---- buy now / add to cart ---- */
    function showErr(msg) { if (!errEl) return; errEl.textContent = msg || ''; errEl.hidden = !msg; }
    function busy(btn, on) { if (btn) { if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy'); } }
    function needOptions() {
      if (picked || !groups.length) return false;
      closeDlg(dd);
      var g = groups[0];
      var y = g.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      g.classList.add('sp-flash'); setTimeout(function () { g.classList.remove('sp-flash'); }, 1600);
      showErr('Please select your ' + (g.getAttribute('aria-label') || 'option').toLowerCase() + ' first.');
      picked = true;
      return true;
    }
    function buyNow(btn) {
      if (!current || !current.available) return;
      if (needOptions()) return;
      busy(btn, true); showErr('');
      var attrs = {};
      if (cfg.giftProp) attrs[cfg.giftProp] = 'Yes';
      closeDlg(dd);
      /* Razorpay Magic Checkout: Buy Now opens Razorpay checkout for this product.
         Ready once onBuyNowClickMagic and window.Razorpay exist; if tapped earlier, wait for it (up to 10s). */
      var waited = 0, first = true, rzpOnPage = !!document.querySelector('script[src*="razorpay"]') || !!document.getElementById('sh-rzp-tpl');
      if (window.shLazyStart) window.shLazyStart(); /* Razorpay loads on the first interaction; make sure it has started */
      (function go() {
        var ready = typeof window.onBuyNowClickMagic === 'function' && typeof window.Razorpay === 'function';
        if (ready && !first && !go.settled) { go.settled = true; setTimeout(go, 300); return; }
        first = false;
        if (ready && form) {
          var mb = form.querySelector('[data-sp-buynow]') || btn;
          try {
            var ev = new MouseEvent('click', { bubbles: true, cancelable: true });
            Object.defineProperty(ev, 'target', { value: mb });
            window.onBuyNowClickMagic(ev);
            setTimeout(function () { busy(btn, false); }, 2500);
            return;
          } catch (err) {}
        } else if (rzpOnPage && form && (waited += 150) < 10000) { setTimeout(go, 150); return; }
        if (typeof window.shubhaBuyNow === 'function') {
          Promise.resolve(window.shubhaBuyNow(current.id, 1, attrs)).then(function () { setTimeout(function () { busy(btn, false); }, 1500); }, function () { busy(btn, false); });
          return;
        }
        window.location.href = '/cart/' + current.id + ':1';
      })();
    }
    function atc(btn) {
      if (!form || !current || !current.available) return;
      busy(btn, true); showErr('');
      var fd = new FormData(form);
      fd.set('id', String(current.id));
      if (!fd.get('quantity')) fd.set('quantity', '1');
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      var props = {};
      fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props[m[1]] = v; });
      if (cfg.cartType === 'cart') {
        /* fast path: one request, then open the cart (duplicate lines are merged on the cart page) */
        /* native form post: Shopify adds the item and opens the cart in the same request */
        var idField = form.querySelector('[name="id"]'); if (idField) idField.value = String(current.id);
        var rt = form.querySelector('input[name="return_to"]');
        if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
        rt.value = '/cart';
        HTMLFormElement.prototype.submit.call(form);
        return;
      }
      var keyOf = window.shubhaLineKey;
      var mine = keyOf ? keyOf({ variant_id: current.id, properties: props }) : null;
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var hit = mine && (cart.items || []).filter(function (i) { return keyOf(i) === mine; })[0];
        if (hit) {
          /* already in cart: add to the same line instead of creating a new one */
          return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: hit.key, quantity: hit.quantity + qty }) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function (c) {
              var now = (c.items || []).filter(function (i) { return i.key === hit.key; })[0];
              if (!now || now.quantity <= hit.quantity) throw { description: 'You already have the maximum available quantity of this item in your cart.' };
              return c;
            });
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
      })
        .then(function () { return window.shubhaMergeCart ? window.shubhaMergeCart() : null; })
        .then(function () { return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }); })
        .then(function (cart) { if (cfg.cartType === 'cart') { window.location.href = '/cart'; return; } busy(btn, false); openDrawer(cart); })
        .catch(function (j) { busy(btn, false); showErr(j && j.description ? j.description : 'Could not add to cart. Please try again.'); });
    }
    /* start preparing the Buy Now checkout as soon as the button is touched */
    root.addEventListener('pointerdown', function (e) {
      var b = e.target.closest && e.target.closest('[data-sp-buynow]'); if (!b) return;
      if (!current || !current.available || !(picked || !groups.length) || typeof window.shubhaBuyNowPrep !== 'function') return;
      var attrs = {}; if (cfg.giftProp) attrs[cfg.giftProp] = 'Yes';
      window.shubhaBuyNowPrep(current.id, 1, attrs);
    });
    root.addEventListener('click', function (e) {
      var t = e.target;
      var kt = t.closest('[data-sp-kf-toggle]');
      if (kt) { var kw = kt.closest('[data-sp-kf]'); var kon = !kw.classList.contains('is-open'); kw.classList.toggle('is-open', kon); kt.setAttribute('aria-expanded', kon); return; }
      var b = t.closest('[data-sp-buynow]'); if (b) { e.preventDefault(); buyNow(b); return; }
      var a = t.closest('[data-sp-atc]'); if (a) { e.preventDefault(); atc(a); return; }
      if (t.closest('[data-sp-guide-open]')) { openDlg(guide); return; }
      if (t.closest('[data-sp-guide-close]')) { closeDlg(guide); return; }
      if (t.closest('[data-sp-dd-open]')) { openDlg(dd); return; }
      if (t.closest('[data-sp-dd-close]')) { closeDlg(dd); return; }
      var o = t.closest('[data-sp-offer]');
      if (o) { var row = o.parentNode; var open = !row.classList.contains('is-open'); row.classList.toggle('is-open', open); o.setAttribute('aria-expanded', open); return; }
      var c = t.closest('[data-sp-copy]');
      if (c) {
        var code = c.getAttribute('data-sp-copy'), old = c.textContent;
        var ok = function () { c.textContent = cfg.copied || 'Copied!'; setTimeout(function () { c.textContent = old; }, 1500); };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(ok, ok); else ok();
        return;
      }
      var m = t.closest('[data-sp-offers-more]');
      if (m) { each(root.querySelectorAll('.sp-offer.is-hidden'), function (r) { r.classList.remove('is-hidden'); }); m.hidden = true; }
    });
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); atc(form.querySelector('[data-sp-atc]')); });

    /* content-section CTAs */
    window.__spBuy = function () {
      if (current && current.available && (cfg.single || picked)) { buyNow(null); return; }
      var t = root.querySelector('#sp-buy') || root;
      var target = groups[0] || t;
      var y = target.getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
      if (groups[0]) { groups[0].classList.add('sp-flash'); setTimeout(function () { groups[0].classList.remove('sp-flash'); }, 1600); picked = true; }
    };

    /* desc: hide "Read More" when text is short */
    var rich = root.querySelector('[data-sp-desc]'), more = root.querySelector('[data-sp-dd-open]');
    if (rich && more && rich.scrollHeight <= rich.clientHeight + 4) { rich.classList.remove('is-clamp'); }

    /* ---- mobile fixed order bar after scroll ---- */
    var sk = root.querySelector('[data-sp-sk]');
    var anchor = root.querySelector('[data-sp-actions]') || form;
    if (sk && anchor) {
      var mq = window.matchMedia('(max-width: 767px)');
      var tick = function () {
        var show = mq.matches && anchor.getBoundingClientRect().bottom < 0;
        if (show !== sk.classList.contains('is-vis')) {
          sk.classList.toggle('is-vis', show);
          sk.setAttribute('aria-hidden', show ? 'false' : 'true');
          document.body.classList.toggle('sp-sk-on', show);
        }
      };
      var q = false;
      window.addEventListener('scroll', function () { if (!q) { q = true; requestAnimationFrame(function () { q = false; tick(); }); } }, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      tick();
    }

    /* coming back from checkout with the browser Back button */
    window.addEventListener('pageshow', function () {
      each(root.querySelectorAll('[aria-busy]'), function (el) { el.removeAttribute('aria-busy'); });
    });
  }

  document.addEventListener('click', function (e) {
    var s = e.target.closest && e.target.closest('[data-sp-scroll]'); if (!s) return;
    if (typeof window.__spBuy !== 'function') return;
    e.preventDefault();
    window.__spBuy();
  });

  /* speed mode: photo grids further down the page load when the shopper scrolls near them (sizes are reserved, so nothing moves) */
  function lazySections() {
    var imgs = document.querySelectorAll('img[data-sh-lz]');
    if (!imgs.length) return;
    function fire(im) {
      if (im.getAttribute('data-sh-srcset')) im.setAttribute('srcset', im.getAttribute('data-sh-srcset'));
      if (im.getAttribute('data-sh-src')) im.setAttribute('src', im.getAttribute('data-sh-src'));
      im.removeAttribute('data-sh-lz');
    }
    if (!('IntersectionObserver' in window)) { each(imgs, fire); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        each(e.target.querySelectorAll('img[data-sh-lz]'), fire);
      });
    }, { rootMargin: '700px 0px' });
    var seen = [];
    each(imgs, function (im) {
      var box = im.closest('.shopify-section') || im.parentNode;
      if (seen.indexOf(box) < 0) { seen.push(box); io.observe(box); }
    });
  }

  function boot() { each(document.querySelectorAll('[data-sp-product]'), initProduct); lazySections(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
